module.exports = __webpack_public_path__ + "static/media/contact.a682c16b.png";